// NavigationComponent.js
import React from 'react';

const NavigationComponent = ({ onGameChange, currentGame }) => {
  return (
    <div className="game-navigation">
    <h1>Choose your game</h1>
      <div className="game-tabs">
        <button 
          className={`game-tab ${currentGame === 'coinflip' ? 'active' : ''}`}
          onClick={() => onGameChange('coinflip')}
        >
          <span className="tab-icon">🟡</span>
          <span className="tab-name">Coinflip</span>
        </button>
        <button 
          className={`game-tab ${currentGame === 'keno' ? 'active' : ''}`}
          onClick={() => onGameChange('keno')}
        >
          <span className="tab-icon">7️⃣</span>
          <span className="tab-name">Keno</span>
        </button>
      </div>
    </div>
  );
};

export default NavigationComponent;